import apiService from './api';

export enum ClientType {
  COMPAGNIE_MINIERE = 'COMPAGNIE_MINIERE',
  JUNIOR_MINING = 'JUNIOR_MINING',
  CONSULTANT = 'CONSULTANT',
  LABORATOIRE = 'LABORATOIRE',
  GOUVERNEMENT = 'GOUVERNEMENT',
  UNIVERSITE = 'UNIVERSITE',
}

export interface Client {
  id: string;
  tenant_id: string;
  code: string;
  company_name: string;
  client_type: ClientType;
  contact_person?: string;
  email: string;
  phone: string;
  address: string;
  city?: string;
  postal_code?: string;
  country: string;
  is_active: boolean;
  created_at: string;
  updated_at: string;
  samples_count?: number;
  last_sample_date?: string;
}

export interface CreateClientDto {
  company_name: string;
  client_type: ClientType;
  contact_person?: string;
  email: string;
  phone: string;
  address: string;
  city?: string;
  postal_code?: string;
  country: string;
  portal_password?: string; // 🚀 Password for client portal access
}

export interface UpdateClientDto extends Partial<CreateClientDto> {
  is_active?: boolean;
}

export interface ClientFilters {
  client_type?: ClientType[];
  is_active?: boolean;
  search?: string;
}

export interface ClientListResponse {
  clients: Client[];
  total: number;
  page: number;
  limit: number;
  totalPages: number;
}

class ClientsService {
  async getClients(
    page: number = 1,
    limit: number = 20,
    search?: string,
    clientType?: string
  ): Promise<ClientListResponse> {
    const params = new URLSearchParams({
      page: page.toString(),
      limit: limit.toString(),
    });

    if (search) {
      params.append('search', search);
    }
    if (clientType) {
      params.append('client_type', clientType);
    }

    return apiService.get<ClientListResponse>(`/clients?${params.toString()}`);
  }

  async getActiveClients(): Promise<Array<{
    id: string;
    code: string;
    company_name: string;
    display_name: string;
  }>> {
    return apiService.get<Array<{
      id: string;
      code: string;
      company_name: string;
      display_name: string;
    }>>('/clients/active');
  }

  async getClient(id: string): Promise<Client> {
    return apiService.get<Client>(`/clients/${id}`);
  }

  async createClient(clientData: CreateClientDto): Promise<Client> {
    return apiService.post<Client>('/clients', clientData);
  }

  async updateClient(id: string, clientData: UpdateClientDto): Promise<Client> {
    return apiService.patch<Client>(`/clients/${id}`, clientData);
  }

  async updateClientPortalPassword(id: string, newPassword: string): Promise<{ message: string }> {
    return apiService.patch<{ message: string }>(`/clients/${id}/portal-password`, { 
      portal_password: newPassword 
    });
  }

  async deleteClient(id: string): Promise<{ message: string }> {
    return apiService.delete<{ message: string }>(`/clients/${id}`);
  }
}

export const clientsService = new ClientsService();
export default clientsService; 